import { Roles } from 'Constants/Roles'
import { FieldNames } from 'Constants/FieldNames'
import { SelectItems } from 'Types/selectItems'
import { BlockKeys, RbidosRequestStatuses } from 'Pages/registratorCabinet'
import { SorterItems } from 'Modules'
import { RBIDOS_TYPES } from './orderEdit'

export const closeFilterRoles = [
	Roles.REGISTRAR,
	Roles.PILOT,
	Roles.RUKOVODITEL,
	Roles.CLIENT_IDENTIFIER,
	Roles.MANAGER,
	Roles.HEAD_MANAGER,
]
export const showFilterRoles = [
	Roles.RUKOVODITEL,
	Roles.REGISTRAR_DS,
	Roles.ADMIN,
	Roles.SUPER_ADMIN,
	Roles.TECH_SUPPORT,
	Roles.TECH_SUPPORT_LINE_1,
]

export const OPTIONS_INDENTIFICATION_TYPE: SelectItems = [
	{
		id: 'sberbank_office',
		name: 'В офисе Сбербанка',
	},
	{
		id: 'partner_office',
		name: 'В офисе партнера',
	},
	{
		id: 'field_manager',
		name: 'Выездной менеджер',
	},
]

export const OPTIONS_SELECT_PAYMENT: SelectItems = [
	{
		id: 'paid',
		name: 'Оплачен',
	},
	{
		id: 'not_paid',
		name: 'Не оплачен',
	},
	{
		id: 'not_payable',
		name: 'Не подлежит оплате',
	},
]

export const OPTIONS_SELECT_RESERVE: SelectItems = [
	{
		id: 'started',
		name: 'Резерв запущен',
	},
	{
		id: 'not_started',
		name: 'Резерв не запущен',
	},
	{
		id: 'without_reserve_account',
		name: 'Без резервирования',
	},
]

export const OPTIONS_TYPE_ORGANIZATION: SelectItems = [
	{
		id: 'ip',
		name: 'ИП',
	},
	{
		id: 'ooo',
		name: 'ООО',
	},
]

export const SORT_OPTIONS: SorterItems = [
	{
		id: FieldNames.CREATED_AT,
		name: 'По дате создания',
	},
	{
		id: FieldNames.CHANGED_AT,
		name: 'По дате обновления',
	},
	{
		id: `${FieldNames.LAST_NAME},${FieldNames.FIRST_NAME},${FieldNames.MIDDLE_NAME}`,
		name: 'По клиенту (ФИО)',
	},
]

export enum TYPE_DRS_CM_VISIT {
	OFFICE = 'office',
	MANAGER = 'manager',
}

export const translateDrsCmVisit = {
	[TYPE_DRS_CM_VISIT.OFFICE]: 'В офисе банка',
	[TYPE_DRS_CM_VISIT.MANAGER]: 'Выездной менеджер',
}

export const drsCmVisitOptions: SelectItems = [
	{
		id: TYPE_DRS_CM_VISIT.OFFICE,
		name: translateDrsCmVisit[TYPE_DRS_CM_VISIT.OFFICE],
	},
	{
		id: TYPE_DRS_CM_VISIT.MANAGER,
		name: translateDrsCmVisit[TYPE_DRS_CM_VISIT.MANAGER],
	},
]

export const isEditByStatus = {
	[BlockKeys.CLIENT_DATA]: [
		RbidosRequestStatuses.S_NEW,
		RbidosRequestStatuses.S_CREATED,
		RbidosRequestStatuses.S_REGISTERED,
	],
	[BlockKeys.ORGANIZATION]: [
		RbidosRequestStatuses.S_NEW,
		RbidosRequestStatuses.S_CREATED,
		RbidosRequestStatuses.S_REGISTERED,
		RbidosRequestStatuses.S_CBOL_WAITING,
		RbidosRequestStatuses.S_CBOL_CODE_ACCEPTED,
		RbidosRequestStatuses.S_REQUEST_CREATED,
	],
	[BlockKeys.CHECKING_ACCOUNT]: [
		RbidosRequestStatuses.S_NEW,
		RbidosRequestStatuses.S_CREATED,
		RbidosRequestStatuses.S_REGISTERED,
		RbidosRequestStatuses.S_CBOL_WAITING,
		RbidosRequestStatuses.S_CBOL_CODE_ACCEPTED,
		RbidosRequestStatuses.S_REQUEST_CREATED,
		RbidosRequestStatuses.S_DOCS_LOADED,
		RbidosRequestStatuses.S_PUSH_DOCS_ACCEPTED,
		RbidosRequestStatuses.S_COMPANY_SENT,
		RbidosRequestStatuses.S_DOCS_SENT,
		RbidosRequestStatuses.S_DOCS_GENERATED,
	],
	[BlockKeys.RESERVE]: [
		RbidosRequestStatuses.S_NEW,
		RbidosRequestStatuses.S_CREATED,
		RbidosRequestStatuses.S_REGISTERED,
		RbidosRequestStatuses.S_REQUEST_CREATED,
		RbidosRequestStatuses.S_DOCS_LOADED,
		RbidosRequestStatuses.S_PUSH_DOCS_ACCEPTED,
		RbidosRequestStatuses.S_COMPANY_SENT,
		RbidosRequestStatuses.S_DOCS_SENT,
		RbidosRequestStatuses.S_DOCS_GENERATED,
		RbidosRequestStatuses.S_EXECUTION,
		RbidosRequestStatuses.S_CI_WAIT_PKCS10,
		RbidosRequestStatuses.S_CI_WAIT_CONSUMER_IDENTIFICATION,
		RbidosRequestStatuses.S_CI_CERTIFICATE_ISSUE,
		RbidosRequestStatuses.S_CI_WAIT_CERTIFICATE_RECEIVE,
		RbidosRequestStatuses.S_CI_WAIT_SCAN_UPLOAD,
		RbidosRequestStatuses.S_RBIDOS_FNS_PACKAGE_SEND,
		RbidosRequestStatuses.S_RBIDOS_FNS_RECEIPT_RECEIVED,
		RbidosRequestStatuses.S_CI_COMPLETE,
		RbidosRequestStatuses.S_RBIDOS_CA_VALIDATION_COMPLETE,
	],
	[BlockKeys.ADDITIONAL_PRODUCTS]: [
		RbidosRequestStatuses.S_NEW,
		RbidosRequestStatuses.S_CREATED,
		RbidosRequestStatuses.S_REGISTERED,
		RbidosRequestStatuses.S_CBOL_WAITING,
		RbidosRequestStatuses.S_CBOL_CODE_ACCEPTED,
		RbidosRequestStatuses.S_REQUEST_CREATED,
		RbidosRequestStatuses.S_DOCS_LOADED,
		RbidosRequestStatuses.S_PUSH_DOCS_ACCEPTED,
		RbidosRequestStatuses.S_COMPANY_SENT,
		RbidosRequestStatuses.S_DOCS_SENT,
		RbidosRequestStatuses.S_DOCS_GENERATED,
		RbidosRequestStatuses.S_EXECUTION,
		RbidosRequestStatuses.S_CI_WAIT_PKCS10,
		RbidosRequestStatuses.S_CI_WAIT_CONSUMER_IDENTIFICATION,
		RbidosRequestStatuses.S_CI_CERTIFICATE_ISSUE,
		RbidosRequestStatuses.S_CI_WAIT_CERTIFICATE_RECEIVE,
		RbidosRequestStatuses.S_CI_COMPLETE,
		RbidosRequestStatuses.S_CI_REJECTED,
		RbidosRequestStatuses.S_CI_ERROR,
		RbidosRequestStatuses.S_CI_CANCELED,
		RbidosRequestStatuses.S_CI_WAIT_SCAN_UPLOAD,
		RbidosRequestStatuses.S_RBIDOS_CANCELED_NO_FNS,
		RbidosRequestStatuses.S_RBIDOS_FNS_PACKAGE_SEND,
		RbidosRequestStatuses.S_RBIDOS_FNS_REGISTRATION_REJECTED,
		RbidosRequestStatuses.S_RBIDOS_FNS_RECEIPT_RECEIVED,
		RbidosRequestStatuses.S_RBIDOS_CA_VALIDATION_COMPLETE,
	],
	[BlockKeys.INFOTECS]: [
		RbidosRequestStatuses.S_EXECUTION,
		RbidosRequestStatuses.S_CI_WAIT_PKCS10,
		RbidosRequestStatuses.S_CI_WAIT_CONSUMER_IDENTIFICATION,
		RbidosRequestStatuses.S_CI_CERTIFICATE_ISSUE,
		RbidosRequestStatuses.S_CI_WAIT_CERTIFICATE_RECEIVE,
		RbidosRequestStatuses.S_CI_COMPLETE,
		RbidosRequestStatuses.S_CI_REJECTED,
		RbidosRequestStatuses.S_CI_ERROR,
		RbidosRequestStatuses.S_CI_CANCELED,
		RbidosRequestStatuses.S_CI_WAIT_SCAN_UPLOAD,
		RbidosRequestStatuses.S_RBIDOS_CA_VALIDATION_COMPLETE,
	],
}

export const STATUS_PAYMENT = {
	DEPOSITED: 'DEPOSITED',
	CREATED: 'CREATED',
	APPROVED: 'APPROVED',
}

export const OPTIONS_SCENARIO: SelectItems = [
	{
		id: RBIDOS_TYPES.FREE,
		name: 'РБиДОС',
	},
	{
		id: 'true',
		name: 'РБиДРС',
	},
	{
		id: RBIDOS_TYPES.PAID,
		name: 'РБpro',
	},
]
